module.exports = __webpack_public_path__ + "img/banner.5cd62a8.png";